import { render, staticRenderFns } from "./ProducerPicker.vue?vue&type=template&id=3535b1af"
import script from "./ProducerPicker.vue?vue&type=script&lang=js"
export * from "./ProducerPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports